let config = () => {
    return {
        apiUrl: 'https://portal.kanin.io',
        loginSubDomain: 'https://id.kanin.io',
        clientId: 'spring-security-oauth2-read-client',
        clientSecret: 'ylgb972rcsg0wksg0scooo4wcc0sg8swkgo8ccck08go40koc',
        versionNumber: '2019.2.0',
        buildVersion: "116",
        company: '© 2019 Panaton Software',
        msClientId: 'aa9f55b4-61f1-48b1-a5e3-576ce867c2ae',
        googleClientId: '677631784280-v91gtma2v8l9b39es6deco1qn7kel1bc.apps.googleusercontent.com'
    }
};

export default new config;


// WEBPACK FOOTER //
// ./src/config.js